import { render, staticRenderFns } from "./MpStokListesi.vue?vue&type=template&id=004c9640"
import script from "./MpStokListesi.vue?vue&type=script&lang=js"
export * from "./MpStokListesi.vue?vue&type=script&lang=js"
import style0 from "./MpStokListesi.vue?vue&type=style&index=0&id=004c9640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports